const getHostname = () => window.location.hostname;

/** Consola admin (host aparte). */
export const isAdminHost = (hostname = getHostname()) => hostname === 'admin.terrio.net';

// Ambiente (por ahora: localhost => dev, resto => prod)
const isDevelopment =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === "dev-app.terrio.net" ||
  isAdminHost();

// Construir baseUrl correctamente según el entorno
const getBaseUrl = () => {
  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    return `http://${window.location.hostname}:${window.location.port}`;
  }
  if (window.location.hostname === "dev-app.terrio.net") {
    return "https://dev-app.terrio.net";
  }
  if (isAdminHost()) {
    return "https://admin.terrio.net";
  }
  return "https://app.terrio.net";
};

/** Destino del producto cuando el staff sale de la consola admin. */
export const getProductAppUrl = () => {
  if (isAdminHost()) return 'https://dev-app.terrio.net/#/app';
  return `${window.location.origin}${window.location.pathname}#/app`;
};

// API
export const API_BASE_URL = isDevelopment
  ? 'https://srov6p2rva.execute-api.us-east-1.amazonaws.com'
  : (process.env.REACT_APP_API_BASE_URL || 'https://kztufazgh6.execute-api.us-east-1.amazonaws.com');

export const COGNITO_CONFIG = {
  region: "us-east-1",
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "us-east-1_GTLjshpRL",
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || "4fjb67b4mdepdli7gq3eovtflp",
  identityPoolId: "us-east-1:1b44e8d2-7d33-4ce7-9797-1c3666559125",
  cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN || "argenlot-gtljshprl.auth.us-east-1.amazoncognito.com",
  get callbackUrl() {
    return `${getBaseUrl()}/auth/callback`;
  },
  get logoutUrl() {
    return `${getBaseUrl()}/auth/logout`;
  },
};